module.exports = __webpack_public_path__ + "img/source3_1.f7524c8c.png";